// extracted by mini-css-extract-plugin
export default {"carousel__container":"Carousel_carousel__container__cCqgF","carousel__down":"Carousel_carousel__down__4k3Pu","carousel":"Carousel_carousel__njY+0"};